// extracted by mini-css-extract-plugin
export default {"wrapper":"ConsistencyCheckHistoryExtraPathDetails_wrapper__id-82"};